import { Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../base/baseCreate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class CreateArcTeamDto extends BaseCreateDto<CreateArcTeamDto> {
  @Field(type => String)
  name!: string

  @Field(type => String, {nullable: true})
  image?: string

  @Field(type => String, {nullable: true})
  description?: string

  @Field(type => Int, {nullable: true})
  defaultDisclaimer?: number

  @Field(t => [String], {nullable: true})
  autoApproveEmailAddresses?: string[]

  @Field(t => [String], {nullable: true})
  autoBlockEmailAddresses?: string[]

  @Field(t => [String], {nullable: true})
  autoVipEmailAddresses?: string[]
}
